import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SectionService {

  private selectedSubSectionSubject = new BehaviorSubject<any>(null); // Holds the rowData
  selectedSubSection$ = this.selectedSubSectionSubject.asObservable(); // Expose it as observable

  // Function to update rowData
  setSelectedSubSection(data: any) {
    this.selectedSubSectionSubject.next(data);
    localStorage.setItem('selectedSubsection', data);
  }

  getSelectedSection() {
    return this.selectedSubSectionSubject.getValue();
  }
}
